/* esm.sh - @radix-ui/react-scroll-area@1.2.10 */
export * from "/*@radix-ui/react-scroll-area@1.2.10/esnext/react-scroll-area.mjs";
